//New, backbone powered version of CoreClient
if (typeof Core == 'undefined') Core = {};

"use strict";

// Override Backbone.sync to use the PUT HTTP method for PATCH requests
// when doing Model#save({...}, { patch: true });
var originalSync = Backbone.sync;
Backbone.sync = function(method, model, options) {
    if (method === 'patch') options.type = 'PUT';
    if (method === 'delete') options.dataType = 'text';
    return originalSync(method, model, options);
};

//	Namespace Core with some static functions

if (!Core.contextRoot) Core.contextRoot = '/core';
Core.apiVersion = 13;
Core.MAX_FETCH_RATE = window.localStorage && localStorage.core_max_fetch_rate && !isNaN(localStorage.core_max_fetch_rate) ? Number(localStorage.core_max_fetch_rate) : 0;
Core.SEARCH_RESULTS_LIMIT = 300;
Core.LIST_UPDATE_INTERVAL = 120000;

Core.initialize = function() {
    Core.client = new Core.Client();
    Core.client.initialize();
    return Core.client;
};

Core.randomUUID = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
};

Core.getNewPdfUrl = function(entity, id, internal, language, docIds) {
    var token = Core.apiToken;
    if (internal == null || internal == undefined) internal = false;
    if (language == null || language == undefined) language = 'en';
    var url = PdfService.url + '/' + entity + '/' + id + '?api_token=' + token + '&internal=' + internal + '&language=' + language;
    if (docIds && docIds.length > 0) {
        url += '&doc_ids=' + docIds.join(',');
    }
    return url;
}

Core.getPdfUrl = function(url, groupId) {
    var match = document.cookie.match(/JSESSIONID=([^;]*)/);
    var sessionId;
    if (match && match.length >= 1) sessionId = match[1];
    if (!url) url = location.href;
    var params = { url: url };
    var group = groupId ? Core.client.groups.get(groupId) : null;
    if (group && group.get('timeZone')) params.tz = group.get('timeZone');
    if (!params.tz && Core.client.me.get('timeZone')) params.tz = Core.client.me.get('timeZone');
    if (sessionId) params.sessionid = sessionId;
    return Core.contextRoot + '/../vault/pdf?' + $.param(params);
};

Core.getContentTemplate = function(group, name, callback) {
    return $.get(Core.contextRoot + '/group/' + group + '/content-template/' + name + '/' + Core.language, callback);
};

Core.avatarUrl = function(model) {
    if (!model) return undefined;
    var url = typeof model.get == 'function' ? model.get('avatarUrl') : model.avatarUrl;
    if (!url) return url;
    if (url.indexOf('/') != 0 && url.indexOf('http') != 0) url = '//' + url;
    if (url.indexOf('/vault') == 0) url = Core.addTokenToUrl(url);
    return url;
};

Core.addTokenToUrl = function(url) {
    if (url.indexOf('/vault') == 0 && Core.contextRoot && Core.contextRoot.indexOf('/core') >= 0)
        url = Core.contextRoot.replace('/core', url);
    if (Core.apiToken)
        return url + '?api_token=' + Core.apiToken;
    else if (Core.accessToken)
        return url + '?access_token=' + Core.accessToken;
    else
        return url;
};

Core.setupRefresh = function(callback, interval) {
    if (!interval) interval = Core.LIST_UPDATE_INTERVAL;
    if (window.refreshInterval) clearInterval(window.refreshInterval);
    window.refreshInterval = setInterval(function() {
        if (!document.hidden) {
            console.log('refreshing', new Date());
            window.lastRefresh = new Date();
            if (callback) callback();
        } else
            console.log('not refreshing - hidden', new Date());
    }, interval);
    if (!document.addedVisibilityListener) {
        document.addedVisibilityListener = true;
        document.addEventListener('visibilitychange', function () {
            console.log('visibility change', document.hidden, new Date());
            if (!document.hidden && window.lastRefresh && new Date().getTime() - window.lastRefresh >= interval) {
                console.log('refreshing on visibilitychange', new Date());
                window.lastRefresh = new Date();
                if (callback) callback();
            }
        });
    }
};

// Utility function for allowing params both as query parameters and in hash/fragment
Core.param = function (name) {
    if (location.hash.indexOf('?') > 0) return purl(location.hash.substring(1)).param(name);
    return purl().param(name);
};

Core.imgRoot = '/img';
//	Models

Core.ShareableModel = Backbone.Model.extend({

    editGroupPermission: null,

    isEditable: function() {
        return !this.get('deleted') && !this.get('attestedTimeStamp') && Core.client && Core.client.me.id 
        && (this.isNew() 
            || Core.client.hasPermission('edit_all_data') 
            || this.get('creatorId') == Core.client.me.id
            || (this.get('ordererId') == Core.client.me.id)
            || (this.editGroupPermission && Core.client.hasGroupPermission(this.get('groupId'), this.editGroupPermission)
                && (!this.get('template') || Core.client.hasGroupPermission(this.get('groupId'), 'admin_templates'))
            )
        );
    },

    isValidForGroup: function(groupId) {
        if (!this.get('groupId')) return !groupId;
        if (groupId && typeof groupId == 'object') groupId = groupId.id;
        if (this.get('groupId') == groupId) return true;
        var group = Core.client.groups.get(groupId);
        while (group) {
            if (group && group.get('parentGroupId') && this.get('groupId') == group.get('parentGroupId')) return true;
            group = Core.client.groups.get(group.get('parentGroupId'));
        };
        return false;
    },


});

Core.User = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/user',

    longName: function() {
        return Formatting.longName(this.attributes);
    },
    shortName: function() {
        return Formatting.shortName(this.attributes);
    },
    isSharingAllWithPrimaryGroup: function() {
        return this.get('primaryGroupId') && this.get('shareAllWithPrimaryGroup');
    },
    isEditable: function() {
        if (!Core.client.me.id) return false;
        if (this.get('deleted')) return false;
        return this.isNew() || Core.client.hasPermission('edit_all_data') || this.id == Core.client.me.id 
            || Core.client.hasGroupPermission(this.get('primaryGroupId'), 'admin_member_accounts')
            || (Core.client.primaryGroup() && Core.client.primaryGroup('reseller'));
    },
    isMemberOf: function(groupId) {
        return this.getGroupMembership(groupId) ? true : false;
    },
    isCustomerUserOf: function(groupId) {
        var membership = this.getGroupMembership(groupId);
        if (!membership) return false;
        var group = Core.client.groups.get(groupId);
        var roleId = membership.roleId;
        if (!roleId || !group) return false;
        var role = group.get('roles') && group.get('roles').find(function(role) {
            return role.id === roleId;
        });
        return role && role.permissions && role.permissions.indexOf('view_customer_portal') >= 0;
    },
    getGroupMembership: function(groupId) {
        if (!groupId) return null;
        if (typeof groupId == 'object') groupId = groupId.id;
        return _(this.get('groupMemberships')).findWhere({groupId: groupId});
    },
    isCustomerUserInGroup: function(groupId) {
        if (groupId && typeof groupId == 'object') groupId = groupId.id;
        var membership = _(this.get('groupMemberships')).findWhere({groupId: groupId});
        if (membership && membership.customerId) return true;
        return false;
    },
    getExtensionServiceAccount: function(name) {
        return _(this.get('extensionServices')).findWhere({name: name});
    },
    isPlusUser: function() {
        return this.get('extensionServices') && (this.get('extensionServices').filter(function(extension) { return extension.name == 'Plus' }).length > 0 ? true : false);
    },
    changeActiveGroups: function(newGroupIds, primaryGroupId) {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/active-groups?groups=' + newGroupIds.join(',')
                    + (primaryGroupId ? '&primary=' + primaryGroupId : ''),
            type: 'PUT',
            success: function(data) {
                self.set(data);
            }
        });
    },
    getActiveGroupMemberships: function() {
        return this.get('groupMemberships').filter(function(membership) {
            return membership.active;
        });
    },
    getActiveGroupMembershipIds: function() {
        return this.getActiveGroupMemberships() && this.getActiveGroupMemberships().map(function(membership) {
            return membership.groupId;
        });
    },
    geocode: function() {
        this.geocoding = true;
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/location/geocode',
            type: 'POST',
            success: function(data) {
                if (data) self.set('location', data);
            }
        }).complete(function () {
            self.geocoding = false;
        });
    },

    setVehicle: function(vehicleId) {
        if (!vehicleId || vehicleId < -1) return;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/vehicle/' + vehicleId,
            type: 'PUT',
            contentType: 'application/json',
        });
    },
    isOnTrial: function() {
        return this.get('extensionServices') && (this.get('extensionServices').filter(function(extension) { return extension.trialPeriod }).length > 0 );
    }
});

Core.Users = Backbone.Collection.extend({
    model: Core.User,
    url: function() {
        var path = '';
        var params = {};
        if (this.filterParams) {
            params = this.filterParams.params || {};
            if (typeof this.filterParams.path !== 'undefined') path = '/' + this.filterParams.path;
            if (this.filterParams.groupIds) params.groups = this.filterParams.groupIds.join(',');
        }
        if (this.searchQuery) params.q = this.searchQuery;
        return Core.contextRoot + '/user' + path + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
    },

    initialize: function(models, options) {
        if (options) {
            this.filterParams = options.filterParams;
        }
    },

    getByUserName: function (username) {
        return _(this.models).find(function (user) {
            return user.get('userName') == username;
        });
    },
});

Core.Users.filterCollection = function(filter, collection) {
    var filteredCollection = new Core.Users(collection.models);
    if (collection.searchQuery) return filteredCollection;
    if (filter) {
        if (filter.where)
            filteredCollection = new Core.Users(filteredCollection.where(filter.where));
    }
    return filteredCollection;
};

Core.Permissions = Backbone.Model.extend({
    url: Core.contextRoot + '/user/me/permissions',

    parse: function (data) {
        return { permissions: data };
    }
});

Core.Preference = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/preference',
    idAttribute: 'path',

    initialize: function (options) {
        if (options.path) this.set({path: options.path});
    }
});

Core.Group = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/group',

    url: function() {
        if (this.isNew()) {
            var params = {};
            if (this.templateId) params.templateId = this.templateId;
            if (this.copyContent) params.content = '';
            if (this.copyMembers) params.members = '';
            return this.urlRoot + (params ? '?' + $.param(params) : '');
        } else {
            return this.urlRoot + '/' + this.id;
        }
    },

    isEditable: function() { return Core.client.me.id && this.id && (this.get('creatorId') == Core.client.me.id || Core.client.hasGroupPermission(this.id, 'admin_members')); },

    configuration: function(config) {
        if (this.get('configuration')) return this.get('configuration')[config];
    },

    hasFeature: function(feature) {
        if (this.get('features')) return this.get('features').indexOf(feature) >= 0;
    },

    hasMember: function(userId) {
        return this.getMembership(userId) ? true : false;
    },

    getMembership: function(userId) {
        if (typeof userId == 'object') userId = userId.id;
        return this.get('members') && _(this.get('members')).findWhere({userId: userId});
    },

    memberHasPermission: function(userId, permission) {
        var membership = this.getMembership(userId);
        if (!membership) return false;
        if (membership.permissions && membership.permissions.indexOf(permission) >= 0) return true;
        var role = this.get('roles') && _(this.get('roles')).findWhere({id: membership.roleId});
        if (role && role.permissions && role.permissions.indexOf(permission) >= 0) return true;
        return false;
    },

    addRole: function(role) {
        var roles = this.get('roles');
        if (!role) {
            role = {};
            // copy default permissions from role with least amount of em
            var leastPermissions;
            _(roles).each(function (r) { if (!leastPermissions || r.permissions.length < leastPermissions.length) leastPermissions = r.permissions; });
            role.permissions = _(leastPermissions).clone();
        }
        roles.push(role);
        return role;
    },

    addMember: function(userId) {
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/member/' + userId,
            type: 'POST'
        });
    },

    deleteMember: function(userId) {
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/member/' + userId,
            type: 'DELETE'
        });
    },

    putMemberRole: function(userId, roleId) {
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/member/' + userId + '/role/' + roleId,
            type: 'PUT'
        });
    },

    getOrGetInParentGroup: function(attribute) {
        var group = this;
        while (group) {
            var value = group.get(attribute);
            if (value) return value;
            group = Core.client.groups.get(group.get('parentGroupId'));
        }
        return null;
    },

    isAncestorOf: function(groupId) {
        do {
            var group = Core.client.groups.get(groupId);
            if (group != null) {
                if (group.get('parentGroupId') == this.id) return true;
                groupId = group.get('parentGroupId');
            } else
                groupId = null;
        } while (groupId);
    },

});

Core.Groups = Backbone.Collection.extend({
    model: Core.Group,
    url: function() {
        var path = '';
        var params = {};
        if (this.searchQuery) {
            path = '/search';
            params.q = this.searchQuery;
        }
        return Core.contextRoot + '/group' + path + '?' + $.param(params);
    },
    getGroupAndDescendants: function(groupId) {
        var ids = [];
        if (groupId == null) return ids;
        ids.push(groupId);

        var self = this;
        function addChildren(groupId) {
            self.each(function (group) {
                if (group.get('parentGroupId') == groupId) {
                    ids.push(group.id);
                    addChildren(group.id);
                }
            });
        }
        addChildren(groupId);

        return ids;
    },
    getGroupAndAncestors: function(groupId) {
        var ids = [];
        if (groupId == null) return ids;
        ids.push(groupId);
        this.each(function (group) {
            if (group.isAncestorOf(groupId)) ids.push(group.id);
        });
        return ids;
    },
    comparator: function(a,b) {
        var name = a.get('name') - b.get('name');
        if (name === 0) {
            return a.get('name') < b.get('name') ? -1 : 1;
        }
        return name;
    }
});

Core.Activity = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/activity',
    editGroupPermission: 'admin_activities',
});

Core.Activities = Backbone.Collection.extend({
    model: Core.Activity,
    url: Core.contextRoot + '/activity'
});

Core.Category = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/category',
    editGroupPermission: 'admin_categories',
});

Core.Categories = Backbone.Collection.extend({
    model: Core.Category,
    url: Core.contextRoot + '/category'
});

Core.Customer = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/customer',
    editGroupPermission: 'admin_customers',

    defaults: function() { return {
        active: true,
        invoiced: true,
        chargedVat: true,
        type: 'BUSINESS',
        documents: [],
        language: Core.language
    }; },

    setFromTemplate: function (template, previousTemplate) {
        if (!template) return;
        var attributes = $.extend(true, {}, template.attributes);
        delete attributes.id;
        delete attributes.uuid;
        delete attributes.lastModified;
        delete attributes.creatorId;
        delete attributes.creationTimeStamp;
        delete attributes.name;
        delete attributes.customerNo;
        delete attributes.projects;
        if ('groupId' in this.attributes) {
            delete attributes.groupId;
            delete attributes.groupUuid;
        }
        if (attributes.documents)
            _(attributes.documents).each(function (document) { delete document.id; delete document.uuid; });
        delete attributes.template;
        if (previousTemplate) {
            delete attributes.jobContact;
            delete attributes.location;
            delete attributes.invoiceContact;
            delete attributes.invoiceAddress;
            delete attributes.type;
            delete attributes.active;
            delete attributes.invoiced;
            if (this.get('ourReference') != previousTemplate.get('ourReference')) delete attributes.ourReference;
            if (this.get('ourReferenceUserId') != previousTemplate.get('ourReferenceUserId')) delete attributes.ourReferenceUserId;
            if (this.get('termsOfPaymentDays') != previousTemplate.get('termsOfPaymentDays')) delete attributes.termsOfPaymentDays;
            if (this.get('description') != previousTemplate.get('description')) delete attributes.description;
            if (this.get('locationDescription') != previousTemplate.get('locationDescription')) delete attributes.locationDescription;
        }
        this.set(attributes);
    },

    updateFromTemplate: function (template, previousTemplate) {
        // If editing existing customer, apply template custom fields
        var oldCustomFields = this.get('customFields');
        var newCustomFields = $.extend(true, [], template.get('customFields'));
        _(newCustomFields).each(function (field) {
            var oldField = _(oldCustomFields).findWhere({name: field.name});
            if (oldField) field.value = oldField.value;
        });
        _(oldCustomFields).each(function (oldField) {
            if (oldField.value && !_(newCustomFields).findWhere({name: oldField.name})) {
                newCustomFields.push(oldField);
            }
        });
        this.set({customFields: newCustomFields});
    },

    putCustomerProject: function(customerProject) {
        if (!this.get('projects')) this.set('projects',[]);
        if (!customerProject.id || !this.getCustomerProjectById(customerProject.id))
            this.get('projects').push(customerProject);
        return $.ajax({
            url: this.urlRoot + '/' + (this.get('uuid') || this.id) + '/project/' + customerProject.uuid,
            type: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify(customerProject)
        });
    },

    getCustomerProjectById: function(customerProjectId) {
        return _(this.get('projects')).findWhere({id: customerProjectId});
    },

    getCustomerProjectByUuid: function(customerProjectUuid) {
        return _(this.get('projects')).findWhere({uuid: customerProjectUuid});
    },

    geocode: function() {
        if (this.get('jobLocations')) {
            // Geocode the FIRST NON-GEOCODED address (and return the xhr object)
            for (var i = 0; i < this.get('jobLocations').length; i++) {
                var destination = this.get('jobLocations')[i];
                if (!destination.location) destination.location = {};
                if (!destination.pendingGeocode && (destination.geocodeResult == 'fail' || (destination.location.latitude && destination.location.longitude))) continue;
                if (!destination.location.placeName) continue;
                if (destination.location.placeName.indexOf('<') == 0) continue; // special case for having a label like "<<< pick a place"
                if (destination.isGeocoding) continue;
                destination.isGeocoding = true;
                this.trigger('geocodestart');
                console.log('geocode', destination.location.placeName);
                var self = this;
                return $.getJSON(Core.contextRoot + '/map/search?' + $.param({q: destination.location.placeName}), function (response) {
                    if (response.places && response.places.length >= 1) {
                        var place = response.places[0];
                        console.log(destination.location.placeName + ' => \n' + place.name + ' ' + place.latitude + ' ' + place.longitude + ' - ' + place.type + ' ' + place.source);
                        destination.location.latitude = place.latitude;
                        destination.location.longitude = place.longitude;
                        destination.geocodedPlace = place;
                        if (place.type == 'STREET_ADDRESS' || place.type == 'PLACE')
                            destination.geocodeResult = 'ok';
                        else
                            destination.geocodeResult = 'warn';
                    } else {
                        console.log('geocoding failed', response, destination.location.placeName);
                        delete destination.geocodedPlace;
                        destination.geocodeResult = 'fail';
                    }
                    self.geocodeResult = destination.geocodeResult;
                    delete destination.isGeocoding;
                    delete destination.pendingGeocode;
                    delete destination.geocodedReverse;
                    self.trigger('geocodedone');
                });
            }
        }
    },
});

Core.Customers = Backbone.Collection.extend({
    model: Core.Customer,
    canPaginate: true,

    url: function() {
        var path = '';
        var params = {};
        if (this.filterParams && this.filterParams.path) path = this.filterParams.path;
        if (this.filterParams && this.filterParams.includeInactive) params.inactive = '';
        if (this.filterParams && this.filterParams.groups) params.groups = this.filterParams.groups;
        if (this.searchQuery) {
            params.q = this.searchQuery;
            params.limit = this.searchLimit || Core.SEARCH_RESULTS_LIMIT;
            path = 'search';
        }
        return Core.contextRoot + '/customer' + (path ? '/' + path : '') + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
    },

    initialize: function(models, options) {
        this.filterParams = (options && options.filterParams) || {};
    },

    getCustomerProjectById: function(customerProjectId) {
        for (var i = 0; i < this.models.length; i++) {
            var customer = this.models[i];
            var customerProject = customer.getCustomerProjectById(customerProjectId);
            if (customerProject) return customerProject;
        }
    },

    getCustomerByCustomerProjectId: function(customerProjectId) {
        for (var i = 0; i < this.models.length; i++) {
            var customer = this.models[i];
            if (customer.getCustomerProjectById(customerProjectId)) return customer;
        }
    },
});

Core.Phrase = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/phrase',
    editGroupPermission: 'admin_phrases',
    defaults: function() {
        var phrase = {};
        if (Core.client.primaryGroup() && Core.client.hasGroupPermission(Core.client.primaryGroup(), 'admin_phrases'))
            phrase.groupId = Core.client.primaryGroup().id;
        return phrase;
    },
});

Core.Phrases = Backbone.Collection.extend({
    model: Core.Phrase,
    url: Core.contextRoot + '/phrase'
});

Core.Label = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/label',
    editGroupPermission: 'admin_labels',
    defaults: function() {
        var label = {
            internal: true,
            active: true
        };
        if (Core.client.primaryGroup() && Core.client.hasGroupPermission(Core.client.primaryGroup(), 'admin_labels'))
            label.groupId = Core.client.primaryGroup().id;
        return label;
    },
});

Core.Labels = Backbone.Collection.extend({
    model: Core.Label,
    url: Core.contextRoot + '/label'
});

Core.Message = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/message'
});

Core.Messages = Backbone.Collection.extend({
    model: Core.Message,
    initialize: function(models, options) {
        this.filterParams = (options && options.filterParams) || {};
    },
    url: function() {
        var path = '';
        var params = {};
        if (this.filterParams) {
            if (this.filterParams.path) path = this.filterParams.path;
            if (this.filterParams.from) params.from = this.filterParams.from;
            if (this.filterParams.to) params.to = this.filterParams.to;
            if (this.filterParams.limit) params.limit = this.filterParams.limit;
            if (this.filterParams.offset) params.offset = this.filterParams.offset;
            if (this.filterParams.setRead) params.setread = this.filterParams.setRead;
        }
        return Core.contextRoot + '/message' + (path ? '/' + path : '') + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
    }
});

Core.Todo = Backbone.Model.extend({
    url: Core.contextRoot + '/stats/me/todo'
});

Core.Place = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/place',
    editGroupPermission: 'admin_places',

    geocode: function() {
        var location = this.get('location') || {};
        var self = this;
        return $.getJSON(Core.contextRoot + '/map/search?' + $.param({q: location.placeName}), function (response) {
            if (response.places && response.places.length >= 1) {
                var place = response.places[0];
                console.log(location.placeName + ' => \n' + place.name + ' ' + place.latitude + ' ' + place.longitude + ' - ' + place.type + ' ' + place.source);
                location.latitude = place.latitude;
                location.longitude = place.longitude;
                self.geocodedPlace = place;
                if (place.type == 'STREET_ADDRESS' || place.type == 'PLACE')
                    self.geocodeResult = 'ok';
                else
                    self.geocodeResult = 'warn';
                self.set({location: location}, {silent: true});
            } else {
                console.log('geocoding failed', response, location.placeName);
                delete self.geocodedPlace;
                self.geocodeResult = 'fail';
            }
            delete self.pendingGeocode;
            self.trigger('geocodedone');
        });
    },

    hasValidLocation: function() {
        return this.get('location') && this.get('location').latitude && this.get('location').longitude ? true : false;
    },

});

Core.Places = Backbone.Collection.extend({
    model: Core.Place,
    MAX_SEARCH_RESULTS: Core.SEARCH_RESULTS_LIMIT,
    canPaginate: true,
    url: function() {
        var params = {};
        if (this.filterParams) {
            if (this.filterParams.groups) params.groups = this.filterParams.groups;
            else if (this.filterParams.groupIds) params.groups = this.Filterparams.groupIds.join(',');
            if (this.filterParams.categories) params.categories = this.filterParams.categories;
        }
        return Core.Place.prototype.urlRoot + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
    },

    initialize: function(models, options) {
        this.filterParams = (options && options.filterParams) || {};
    },
});

Core.Places.filterCollection = function(filter, collection) {
    var filteredCollection = new Core.Places(collection.models);
    if (collection.searchQuery) return filteredCollection;
    if (filter) {
        if (filter.where)
            filteredCollection = new Core.Places(filteredCollection.where(filter.where));
        if (filter.groups) {
            var groups = filter.groups;
            filteredCollection = new Core.Places(filteredCollection.filter(function (place) {
                var groupId = place.get('groupId');
                return groups === groupId || ($.isArray(groups) && groups.indexOf(groupId) >= 0);
            }));
        }
        if (filter.categories) {
            var categories = filter.categories;
            filteredCollection = new Core.Places(filteredCollection.filter(function (place) {
                /* filter for non-categorized */
                if (categories === -2 || ($.isArray(categories) && categories.indexOf(-2) >= 0)) return place;
                var categoryId = place.get('categoryId');
                return categories === categoryId || ($.isArray(categories) && categories.indexOf(categoryId) >= 0);
            }));
        }
    }
    return filteredCollection;
};

Core.Article = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/article',
    editGroupPermission: 'admin_articles',

    defaults: function() {
        return {
            unit: 'ITEMS',
            invoiced: true,
            invoicedAmountSpecified: true,
            active: true,
            groupId: Core.client && Core.client.primaryGroup() && Core.client.primaryGroup().id,
        };
    },

    applyToItem: function(item, weight, distance) {
        if (this.id)
            item.articleId = this.id;
        else {
            delete item.articleId;
            item.articleUuid = this.get('uuid');
        }
        if (!item.description || item.description == item.articleDescription)
            item.description = this.get('description');
        else {
            item.description = item.description.replace(item.articleDescription, this.get('description'));
        }
        item.articleNo = this.get('articleNo');
        item.articleDescription = this.get('description');
        item.articleInvoiced = this.get('invoiced');
        item.articleUnitPrice = null;
        item.articleUnitCost = null;
        if (item.currency) {
            var group = Core.client.groups.get(this.get('groupId'));
            if (group && (!group.get('defaultCurrency') || group.get('defaultCurrency') == item.currency))
                item.articleUnitPrice = this.get('unitPrice');
        } else
            item.articleUnitPrice = this.get('unitPrice');
        item.articleUnitCost = this.get('unitCost');
        item.unit = this.get('unit');
        if (this.get('unit') == 'KG' && weight)
            item.amount = weight;
        else if (this.get('unit') == 'KM' && distance)
            item.amount = distance;
        if (item.unit == 'ITEMS' && (item.amount == null || typeof item.amount == 'undefined') && (item.invoicedAmount == null || typeof item.invoicedAmount == 'undefined'))
            item.amount = 1.0;
        item.salaryCode = this.get('salaryCode');
    },

    findUnitPrice: function(amount, currencyCode, weight, distance) {
        var group = Core.client.groups.get(this.get('groupId'));
        var prices = this.get('prices');
        if (prices) {
            // Find in same currency
            for (var i = prices.length-1; i >= 0; i--) {
                var price = prices[i];
                if (this.get('pricedByWeight') && weight && price.minWeight > weight + 1e-5) continue;
                if (this.get('pricedByDistance') && distance && price.minDistance > distance + 1e-5) continue;
                if (amount >= price.minAmount - 1e-5 && (currencyCode == price.currency || (!currencyCode && price.currency == group.get('defaultCurrency'))))
                    return price.unitPrice;
            }
            // Find in prices by translating currency
            if (group) {
                var currencies = group.get('currencies');
                var currency = _(currencies).findWhere({code: currencyCode});
                if (currency && currency.buyRate) {
                    for (var i = prices.length - 1; i >= 0; i--) {
                        var price = prices[i];
                        if (this.get('pricedByWeight') && weight && price.minWeight > weight + 1e-5) continue;
                        if (this.get('pricedByDistance') && distance && price.minDistance > distance + 1e-5) continue;
                        if (amount >= price.minAmount - 1e-5 && (!price.currency || price.currency == group.get('defaultCurrency')))
                            return Math.round(price.unitPrice / currency.buyRate);
                    }
                }
            }
        }
        // Find by default price same currency
        if (!currencyCode || !group || currencyCode == group.get('defaultCurrency'))
            return this.get('unitPrice');
        // Find by default price translating currency
        if (this.get('unitPrice') && group && group.get('defaultCurrency')) {
            var currency = _(group.get('currencies')).findWhere({code: currencyCode});
            if (currency && currency.buyRate) {
                return Math.round(this.get('unitPrice') / currency.buyRate);
            }
        }
    }


});

Core.Articles = Backbone.Collection.extend({
    model: Core.Article,
    canPaginate: true,
    url: function() {
        if (this.customUrl)
            return this.customUrl;
        var url;
        var params = { };
        if (this.filterParams.includeInactive) params.inactive = '';
        if (this.filterParams.groups) params.groups = this.filterParams.groups;
        if (this.searchQuery) {
            url = Core.contextRoot + '/article/search';
            params.q = this.searchQuery;
            if (this.filterParams.includeInactiveInSearch) params.inactive = '';
            params.limit = this.searchLimit || Core.SEARCH_RESULTS_LIMIT;
        } else {
            if (this.filterParams) {
                if (this.filterParams.group) params.group = this.filterParams.group;
                if (this.filterParams.limit) params.limit = this.filterParams.limit;
                if (this.filterParams.offset) params.offset = this.filterParams.offset;
                if (this.filterParams.modified) params.modified = this.filterParams.modified;
            }
            url = Core.contextRoot + '/article' + (this.filterParams.path ? '/'+this.filterParams.path : '');
        }
        var paramsStr = $.param(params);
        if (paramsStr.length > 0) url += '?' + paramsStr;
        return url;
    },
    initialize: function(options) {
        this.filterParams = {};
        if (options && options.url)
            this.customUrl = options.url;
        else if (options && options.filterParams)
            _(this.filterParams).extend(options.filterParams);
    }
});

Core.PriceList = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/price/list',
    editGroupPermission: 'pricing',
});

Core.PriceLists = Backbone.Collection.extend({
    model: Core.PriceList,
    url: Core.contextRoot + '/price/list',
});

Core.Event = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/event'
});

Core.Events = Backbone.Collection.extend({
    model: Core.Event,

    url: function() {
        if (!this.filterParams) this.filterParams = {};
        var path = Core.Event.prototype.urlRoot;
        if (this.filterParams.path) path += '/' + this.filterParams.path;
        return path + '?' + $.param(this.filterParams.params);
    },

    initialize: function(options) {
        this.filterParams = { params: { limit: 10 }};
        if (options && options.filterParams)
            _(this.filterParams).extend(options.filterParams);
    },
});

Core.Announcement = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/announcement'
});

Core.Announcements = Backbone.Collection.extend({
    model: Core.Announcement,
    url: Core.contextRoot + '/announcement',
});

Core.AvailabilityEntry = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/availability'
});

Core.Availability = Backbone.Collection.extend({
    model: Core.AvailabilityEntry,

    url: function() {
        var params = {
            from: this.from,
            group: this.group
        };
        if (this.to) params.to = this.to;
        return Core.contextRoot + '/' + this.type + '/availability?' + $.param(params);
    },

    initialize: function(models, options) {
        this.type = options.type;
        this.from = options.from;
        this.to = options.to;
        this.group = options.group;
    },
});

Core.Favourite = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/myfavourites',
});

Core.Favourites = Backbone.Collection.extend({
    model: Core.Favourite,
    url: Core.contextRoot + '/myfavourites',

    getByTypeAndEntityUuid: function(entityType, entityUuid) {
        entityType = entityType.toLowerCase();
        return _(this.models).find(function(favourite) {
            var type = favourite.get('type').toLowerCase();
            var uuid = favourite.get('entityUuid');
            return type === entityType && uuid === entityUuid;
        }, this);
    },
});

Core.RemoteSignature = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/remotesignature'
})

Core.SystemMessages = Backbone.Collection.extend({
    url: Core.contextRoot + '/systemmessage/mine',
});

Core.TransportDocument = Backbone.Model.extend({
    urlRoot: Core.contextRoot + '/transportdocument',

    shareByEmail: function(emailAddress, message) {
        var data = { to: emailAddress, message: message };
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/share',
            type: 'POST',
            data: data
        }).success(function(data) {
            console.log('shared transport document', data);
        });
    },

    reopen: function() {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/reopen',
            type: 'PUT',
            dataType: 'json'
        }).done(function(response) {
            self.set(response);
        });
    },
});

Core.TransportDocuments = Backbone.Collection.extend({
    model: Core.TransportDocument,
    url: function() {
        var params = {};
        if (this.filterParams) {
            params = this.filterParams.params || {};
            if (this.filterParams.groupUuids) params.groups = this.filterParams.groupUuids.join(',');
            if (this.filterParams.from) params.from = this.filterParams.from;
            if (this.filterParams.to) params.to = this.filterParams.to;
            if (this.filterParams.limit) params.limit = this.filterParams.limit;
            if (this.filterParams.offset) params.offset = this.filterParams.offset;
            if (this.filterParams.customerIds) params.customers = this.filterParams.customerIds.join(',');
            if (this.filterParams.customerProjectIds) params.customerProjects = this.filterParams.customerProjectIds.join(',');
            if (this.filterParams.integrationStatus && [].concat(this.filterParams.integrationStatus).length > 0) params.integrationStatus = [].concat(this.filterParams.integrationStatus).join(',');
        }
        return Core.contextRoot + '/transportdocument/list' + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
    }
});

Core.TransportDocumentFilterables = Backbone.Model.extend({
    url: function() {
        var params = {};
        if (this.filterParams) {
            params = this.filterParams.params || {};
            if (this.filterParams.groupUuids) params.groups = this.filterParams.groupUuids.join(',');
        }
        return Core.contextRoot + '/transportdocument/list/filterables?' + $.param(params);
    }
});

// Calls to the NVV report endpoints in core (contract 6.2). Always call these through the object
// (Core.TransportDocumentIntegration.send(...)) so they can be replaced when testing manually.
Core.TransportDocumentIntegration = {
    url: function() {
        return Core.contextRoot + '/transportdocumentintegration';
    },
    send: function(payload) {
        return $.ajax({
            url: this.url(),
            type: 'POST',
            data: JSON.stringify(payload),
            contentType: 'application/json',
            dataType: 'json'
        });
    },
    fetchBatch: function(batchUuid) {
        return $.ajax({
            url: this.url() + '?batch=' + encodeURIComponent(batchUuid),
            type: 'GET',
            dataType: 'json'
        });
    },
    retry: function(rowUuid) {
        return $.ajax({
            url: this.url() + '/' + encodeURIComponent(rowUuid) + '/retry',
            type: 'POST',
            dataType: 'json'
        });
    },
    resolve: function(rowUuid, body) {
        return $.ajax({
            url: this.url() + '/' + encodeURIComponent(rowUuid) + '/resolve',
            type: 'POST',
            data: JSON.stringify(body),
            contentType: 'application/json',
            dataType: 'json'
        });
    }
};

//	Client

Core.setupTokens = function(apiToken, accessToken) {
    if (!apiToken)
        apiToken = Core.param('api_token');
    if (!accessToken)
        accessToken = Core.param('access_token');

    try {
        if (sessionStorage.core_apiToken && sessionStorage.core_apiToken != apiToken)
            sessionStorage.clear();
        if (apiToken)
            sessionStorage.core_apiToken = apiToken;
    } catch (e) {} // SecurityError

    Core.apiToken = apiToken;
    Core.accessToken = accessToken;

    if (Core.param('api_key'))
        Core.apiKey = Core.param('api_key');

    $(document).ajaxSend(function(e, xhr, options) {
        xhr.setRequestHeader('API-Version', Core.apiVersion);
        if (Core.apiKey)
            xhr.setRequestHeader('API-Key', Core.apiKey);
        if (apiToken)
            xhr.setRequestHeader('API-Token', apiToken);
        if (accessToken)
            xhr.setRequestHeader('X-Access-Token', accessToken);
        if (Core.language)
            xhr.setRequestHeader('Accept-Language', Core.language);
    });
};

Core.Client = function() {
    this.me = new Core.User();
    this.me.url = this.me.urlRoot + '/me';
    this.permissions = new Core.Permissions();
    if (Core.preload) {
        this.me.set(this.me.parse(Core.preload.me));
        this.permissions.set(this.permissions.parse(Core.preload.permissions));
    } else if (Core.apiToken) {
        this.me.setCacheOptions({key: 'core_me'});
        this.permissions.setCacheOptions({key: 'core_permissions'});
        this.me.getCachedOrFetch();
        this.permissions.getCachedOrFetch();
    }

    this.users = new Core.Users();
    this.users.setCacheOptions({key: 'core_users', ttl: 3600, store: 'local'});
    this.groups = new Core.Groups();
    this.groups.comparator = 'name';
    this.groups.setCacheOptions({key: 'core_groups', ttl: 3600, store: 'local'});
    this.activities = new Core.Activities();
    this.activities.setCacheOptions({key: 'core_activities', ttl: 3600, store: 'local'});
    this.categories = new Core.Categories();
    this.categories.setCacheOptions({key: 'core_categories', ttl: 3600, store: 'local'});
    this.places = new Core.Places();
    this.places.setCacheOptions({key: 'core_places', ttl: 3600, store: 'local'});
    this.customers = new Core.Customers();
    this.customers.setCacheOptions({key: 'core_customers', ttl: 3600, store: 'local'});
    this.customerTemplates = new Core.Customers([], {filterParams: {path: 'templates'}});
    this.customerTemplates.canPaginate = false;
    this.customerTemplates.setCacheOptions({key: 'core_customerTemplates', store: 'local'});
    this.phrases = new Core.Phrases();
    this.phrases.setCacheOptions({key: 'core_phrases', ttl: 3600, store: 'local'});
    this.labels = new Core.Labels();
    this.labels.setCacheOptions({key: 'core_labels', ttl: 3600, store: 'local'});
    this.articles = new Core.Articles();
    this.articles.filterParams.path = 'selectable';
    this.articles.canPaginate = false;
    this.articles.setCacheOptions({key: 'core_articles', ttl: 3600, store: 'local'});
    this.priceLists = new Core.PriceLists();
    this.priceLists.setCacheOptions({key: 'core_priceLists', ttl: 3600, store: 'local'});
    this.myFavourites = new Core.Favourites();
    this.myFavourites.setCacheOptions({key: 'core_myFavourites', ttl: 3600, store: 'local'});
    this.systemMessages = new Core.SystemMessages();
    this.systemMessages.setCacheOptions({key: 'systemMessages',  ttl: 0, store: 'local'});

    if (Core.AssetTypes) {
        this.assetTypes = new Core.AssetTypes([], {filterParams: {path: 'list'}});
        this.assetTypes.setCacheOptions({key: 'core_assetTypes', ttl: 3600, store: 'local'});
    }
    if (Core.Assets) {
        this.assets = new Core.Assets();
        this.assets.setCacheOptions({key: 'core_assets', ttl: 3600, store: 'local'});
    }
    if (typeof Jobs !== 'undefined') {
        this.jobTemplates = new Jobs([], {filterParams: {path: 'templates', includeDrafts: false}});
        this.jobTemplates.setCacheOptions({key: 'core_jobTemplates', store: 'local'});
        this.jobs = new Jobs();
    }
    if (typeof WorkReports !== 'undefined') {
        this.reportTemplates = new WorkReports([], {filterParams: {path: 'templates', includeDrafts: false}});
        this.reportTemplates.setCacheOptions({key: 'core_reportTemplates', store: 'local'});
        this.reports = new WorkReports();
    }
    if (typeof Routes !== 'undefined') {
        this.routeTemplates = new Routes([], {filterParams: {path: 'templates', includeDrafts: false}});
        this.routeTemplates.setCacheOptions({key: 'core_routeTemplates', store: 'local'});
        this.routes = new Routes();
    }
    if (typeof JobOrders !== 'undefined') {
        this.orderTemplates = new JobOrders([], {filterParams: {path: 'templates', includeDrafts: false}});
        this.orderTemplates.setCacheOptions({key: 'core_orderTemplates', store: 'local'});
        this.orders = new JobOrders();
    }
    if (typeof CustomForms !== 'undefined') {
        this.formTemplates = new CustomForms([], { filterParams: { path: 'templates' }});
        this.formTemplates.setCacheOptions({key: 'core_formTemplates', store: 'local'});
    }
    if (typeof Reservations !== 'undefined') {
        this.reservationTemplates = new Reservations([], {filterParams: {path: 'templates', includeDrafts: false}});
        this.reservationTemplates.setCacheOptions({key: 'core_reservationTemplates', store: 'local'});
        this.reservations = new Reservations();
    }
    if (typeof Core.Contracts !== 'undefined') {
        this.contracts = new Core.Contracts();
        this.contracts.setCacheOptions({key: 'core_contracts', store: 'local'});
    }
    if (typeof Projects !== 'undefined') {
        this.projects = new Projects();
        this.projects.setCacheOptions({key: 'core_projects', store: 'local'});
    }
    if (typeof Things.Devices !== 'undefined') {
        this.devices = new Things.Devices();
        this.devices.setCacheOptions({key: 'core_devices', ttl: 3600, store: 'local'});
    }

    if (window.localStorage) {
        if (localStorage.me_id && this.me.id && localStorage.me_id != this.me.id) localStorage.clear();
        if (this.me.id) localStorage.me_id = this.me.id;
    }
};

Core.Client.prototype.initialize = function() {
    if (Core.apiToken) {
        if (!this.me.id) this.me.fetch();
        if (!this.permissions.loaded && !this.permissions.loading) this.permissions.fetch();
        this.groups.getCachedOrFetch();
    }
};

Core.Client.prototype.clear = function(options) {
    if (!options) options = {};
    _([
        this.me, this.permissions, this.users, this.groups,
        this.activities, this.categories, this.places, this.customers,
        this.customerTemplates, this.phrases, this.labels, this.articles,
        this.priceLists, this.assetTypes, this.assets, this.vehicles,
        this.jobTemplates, this.jobs, this.reportTemplates, this.reports,
        this.orderTemplates, this.orders, this.formTemplates,
        this.routeTemplates, this.routes,
        this.reservationTemplates, this.reservations,
        this.calendarJobs, this.calendarOrders, this.calendarReports, this.calendarReservations,
        this.contracts, this.projects, this.systemMessages
    ]).each(function (collection) {
        if (!collection) return;
        if (options.keepMe && (collection == this.me || collection == this.permissions)) return;
        if (collection.clearCache && !options.keepCache) collection.clearCache();
        if (collection.reset) collection.reset();
        if (collection.clear) collection.clear();
        if (collection.loaded) collection.loaded = false;
        if (collection.totalCount) collection.totalCount = null;
    }, this);
};

Core.Client.prototype.hasFeature = function(feature) {
    var features = this.me.get('features');
    return features && features.indexOf(feature) >= 0;
};

Core.Client.prototype.hasPermission = function(permission) {
    var permissions = this.permissions.get('permissions');
    return typeof permissions != 'undefined' && permissions.indexOf(permission) >= 0;
};

Core.Client.prototype.hasGroupPermission = function(groupId, permission) {
    if (groupId && typeof groupId == 'object' && groupId.id) groupId = groupId.id;
    if (Array.isArray(permission)) {
        var hasAll = true;
        _(permission).each(function(p) { if (!this.hasGroupPermission(groupId, p)) hasAll = false; }, this);
        return hasAll;
    }
    if (this.me && this.me.get('groupMemberships')) {
        var membership = _(this.me.get('groupMemberships')).findWhere({groupId: parseInt(groupId)});
        if (!membership) membership = _(this.me.get('groupMemberships')).findWhere({groupUuid: groupId});
        if (membership && membership.permissions) return membership.permissions.indexOf(permission) >= 0;
    }
    return false;
};

Core.Client.prototype.hasPermissionInAnyGroup = function(permission) {
    var foundIt = false;
    if (this.me && this.me.get('groupMemberships')) {
        _(this.me.get('groupMemberships')).each(function (membership) {
            if (membership && membership.permissions && membership.permissions.indexOf(permission) >= 0) foundIt = true;
        }, this);
    }
    return foundIt;
};

Core.Client.prototype.hasPermissionInAnyOfGroups = function(permission, groups) {
    for (var i = 0; i < groups.length; i++) {
        if (this.hasGroupPermission(groups[i], permission)) return true;
    }
    return false;
};

Core.Client.prototype.hasPermissionInGroupOrDescendant = function(groupId, permission) {
    if (!groupId || !permission) return false;
    var groupIds = this.groups.getGroupAndDescendants(groupId);
    for (var i = 0; i < groupIds.length; i++) {
        if (this.hasGroupPermission(groupIds[i], permission)) return true;
    }
    return false;
};

Core.Client.prototype.groupIdsWithPermission = function(permission) {
    var groupIds = [];
    if (this.me && this.me.get('groupMemberships')) {
        _(this.me.get('groupMemberships')).each(function (membership) {
            if (this.hasGroupPermission(membership.groupId, permission)) groupIds.push(parseInt(membership.groupId));
        }, this);
    }
    return groupIds;
};

Core.Client.prototype.hasConfigurationInAnyGroup = function(configuration) { 
    var hasIt = false;   
    if (this.me && this.me.get('groupMemberships')) {
        _(this.me.get('groupMemberships')).each(function (membership) {
            if (membership && membership.groupId)
                if (this.groupHasConfiguration(membership.groupId, configuration))
                    hasIt = true;
        }, this);
    }
    return hasIt;
};

Core.Client.prototype.groupHasConfiguration = function(groupId, configuration) {
    var group = this.groups.get(groupId);
    if (!group) return;
    return configuration in group.get('configuration');
};

Core.Client.prototype.hasFeatureInAnyGroup = function(feature) { 
    var hasIt = false;   
    if (this.me && this.me.get('groupMemberships')) {
        _(this.me.get('groupMemberships')).each(function (membership) {
            if (membership && membership.groupId)
                if (this.groupHasFeature(membership.groupId, feature))
                    hasIt = true;
        }, this);
    }
    return hasIt;
};
Core.Client.prototype.groupHasFeature = function(groupId, feature) {
    var group = this.groups.get(groupId);
    if (!group) return;
    return feature && group.get('features') && group.get('features').indexOf(feature) >= 0;
};

Core.Client.prototype.groupHasintegrationAction = function(groupId, integrationAction) {
  var group = this.groups.get(groupId);
  if (!group) return;
  return integrationAction && group.get('integrationActions') && group.get('integrationActions').indexOf(integrationAction) >= 0;
};
Core.Client.prototype.hasIntegrationActionInGroupOrAncestor = function(groupId, integrationAction) {
    if (!groupId || !integrationAction) return false;
    var groupIds = this.groups.getGroupAndAncestors(groupId);
    for (var i = 0; i < groupIds.length; i++) {
        if (this.groupHasintegrationAction(groupIds[i], integrationAction)) return true;
    }
    return false;
};
Core.Client.prototype.primaryGroup = function() {
    return this.groups.get(this.me.get('primaryGroupId'));
};

Core.Client.prototype.primaryGroupHasConfiguration = function(configuration) {
    return this.primaryGroup() && this.groupHasConfiguration(this.primaryGroup(), configuration);
};

Core.Client.prototype.primaryGroupConfiguration = function(configuration) {
    if (this.primaryGroup() && this.primaryGroup().get('configuration'))
        return this.primaryGroup().get('configuration')[configuration];
};

Core.Client.prototype.userHasGroupPermission = function(userId, groupId, permission) {
    if (userId && typeof userId == 'object') userId = userId.id;
    if (groupId && typeof groupId == 'object') groupId = groupId.id;
    var group = this.groups.get(groupId);
    if (!group) return undefined;
    var membership = _(group.get('members')).findWhere({userId: userId});
    if (!membership) return false;
    if (membership.permissions) return membership.permissions.indexOf(permission) >= 0;
    var role = _(group.get('roles')).findWhere({id: membership.roleId});
    if (!role) return false;
    if (role.permissions) return role.permissions.indexOf(permission) >= 0;
};

Core.Client.prototype.userHasPermissionInAnyGroup = function(userId, permission) {
    if (!this.groups || this.groups.length == 0) return undefined;
    for (var i = 0; i < this.groups.length; i++) {
        if (this.userHasGroupPermission(userId, this.groups.at(i).id, permission)) return true;
    }
    return false;
};

Core.Client.prototype.getOrFetchArticlesByNo = function(articleNo, callback, errorCallback) {
    var cachedArticles = this.articles.filter(function (article) {
        return article.get('articleNo') == articleNo;
    });
    if (cachedArticles && cachedArticles.length > 0) {
        if (callback) callback(cachedArticles);
    }
    var filterParams = {path: 'no?articleNo=' + encodeURIComponent(articleNo) };
    var articles = new Core.Articles({filterParams: filterParams});
    // Avoid launching massive numbers of requests, restricting to one fetch job per articleNo
    if (this._fetchArticlesByNoJob && this._fetchArticlesByNoJob[articleNo]) {
        this._fetchArticlesByNoJob[articleNo].success(callback).error(errorCallback);
        return;
    }
    if (!this._fetchArticlesByNoJob) this._fetchArticlesByNoJob = {}
    var self = this;
    this._fetchArticlesByNoJob[articleNo] = articles.fetch().success(function (articles) {
        articles.forEach(function (article) {
            self.articles.add(article);
        })
        delete self._fetchArticlesByNoJob[articleNo];
        if (callback) callback(articles);
    }).error(function(error) {
        delete self._fetchArticlesByNoJob[articleNo];
        if (errorCallback) errorCallback(error);
    });
};

Core.Client.prototype.searchArticles = function(query, limit) {
    var articles = new Core.Articles();
    articles.searchQuery = query;
    articles.searchLimit = limit;
    return articles.fetch();
};

Core.Client.prototype.fetchItemPrices = function(items, customerId, customerProjectId, params) {
    var url = Core.contextRoot + '/price/';
    if (customerId)
        url += 'customer/' + customerId + '/';
    if (customerProjectId)
        url += 'project/' + customerProjectId + '/';
    url += 'items' + (params ? '?' + $.param(params) : '');
    return $.ajax({
        url: url,
        type: 'POST',
        data: JSON.stringify(items),
        contentType: 'application/json'
    });
};

Core.Client.prototype.addExtensionServiceToUser = function(service, user, exclusive) {
    return $.ajax({
        url: Core.contextRoot + '/user/' + (user ? user : 'me') + '/serviceaccount/' + service + (exclusive ? '?exclusive' : ''),
        type: 'POST'
    });
};

Core.Client.prototype.deleteExtensionServiceToUser = function(service, user) {
    return $.ajax({
        url: Core.contextRoot + '/user/' + (user ? user : 'me') + '/serviceaccount/' + service,
        type: 'DELETE'
    });
};

Core.Client.prototype.validateToken = function(callback) {
    return $.getJSON(Core.contextRoot + '/auth/validate', callback);
};
